import classNames from 'classnames';
import { debounce } from 'lodash/fp';
import * as React from 'react';
import { useCallback, useEffect, useState } from 'react';
import { NAVIGATION } from '../../intercom/intercom-data-targets';
import NavigationList from './List';

type Props = {
    closeNavigation: () => void;
};

const useShouldNavigationScroll = () => {
    const [shouldScroll, setShouldScroll] = useState(false);
    const [element, setElement] = useState<Element | null>(null);

    const ref = useCallback((newElement: Element | null) => {
        setElement(newElement);
    }, []);

    useEffect(() => {
        if (!element) {
            return;
        }

        const resizeHandler = debounce(500, () => {
            setShouldScroll(element.scrollHeight > element.clientHeight);
        });
        const resizeObserver = new ResizeObserver(resizeHandler);

        resizeObserver.observe(element);
        window.addEventListener('resize', resizeHandler);

        return () => {
            resizeObserver.disconnect();
            window.removeEventListener('resize', resizeHandler);
        };
    }, [element]);

    return { shouldScroll, ref };
};

const MainNavigationInner: React.FC<React.PropsWithChildren> = ({ children }) => {
    const { shouldScroll, ref } = useShouldNavigationScroll();

    return (
        <div
            className={classNames('main_navigation-inner', { 'main_navigation-inner--scroll': shouldScroll })}
            ref={ref}
            data-intercom-target={NAVIGATION.WRAPPER}
        >
            {children}
        </div>
    );
};

const MainNavigation: React.FC<Props> = ({ closeNavigation }) => {
    return (
        <div className="main-navigation-container">
            <button className="menu_overlay" aria-label="Close navigation menu." onClick={closeNavigation}></button>

            <div className="main_navigation">
                <MainNavigationInner>
                    <NavigationList />
                </MainNavigationInner>
            </div>
        </div>
    );
};

export default MainNavigation;
